import { useQuery } from '@tanstack/react-query';

import { EpdRegistryFilters } from '@app/models/orders';
import Api from '@app/services/api';

export const useEpdDocumentsQuery = (params: EpdRegistryFilters) =>
  useQuery({
    queryKey: ['epd', 'documents', params],
    queryFn: () => Api.orders.getEpdDocuments(params),
    keepPreviousData: true,
  });
